/** Padded rank for leaderboard UI (matches modal list column). */
export function formatLeaderboardRank(rank: number): string {
	return String(rank).padStart(2, "0");
}

const TROPHY_BY_RANK: Record<1 | 2 | 3, string> = {
	1: "first_place.svg",
	2: "second_place.svg",
	3: "third_place.svg"
};

/**
 * Public URL for leaderboard trophy art under `public/leaderboard/`.
 * Medals follow **rank** (1st–3rd); all other ranks use `regular_place.svg`.
 */
export function getLeaderboardTrophyPublicPath(rank: number): string {
	const base = (process.env.PUBLIC_URL ?? "").replace(/\/$/, "");
	const file =
		rank >= 1 && rank <= 3 ? TROPHY_BY_RANK[rank as 1 | 2 | 3] : "regular_place.svg";
	return `${base}/leaderboard/${file}`;
}
